// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import {
  Input,
  Button,
} from '../../../../../../../../components';

import styles from './styles';


class SearchForm extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    text: PropTypes.string,
    activateClearButton: PropTypes.bool,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    onClear: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    text: null,
    activateClearButton: false,
    onChange: () => { },
    onSearch: () => { },
    onClear: () => { },
  };

  // A handheld scanner types the voucher code and sends Enter, so without
  // this a scan filled the box and then sat there until somebody clicked
  // SEARCH - which defeats the point of scanning.
  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.props.onSearch();
    }
  }

  render() {
    const {
      classes,
      text,
      activateClearButton,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.inputContainer}>
          <Input
            style={styles.input}
            name={'text'}
            placeholder={'Search by name, email or voucher id'}
            fixedWidth={false}
            value={text}
            minLength={0}
            maxLength={250}
            resetButton={(text !== '' || activateClearButton)}
            onChange={(value, name) => this.props.onChange(value, name)}
            onClick={() => this.props.onClear()}
            onKeyDown={this.onKeyDown}
            autoFocus
          />
        </div>
        <Button
          text={'SEARCH'}
          style={classes.button}
          onPress={() => this.props.onSearch()}
        />
      </div>
    );
  }
}

export default (withStyles(styles)(SearchForm));
